// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".white-layout[data-v-3c2c464c]{background-color:#fff}.layout-container[data-v-3c2c464c]{padding-top:91px}.main-content-layout[data-v-3c2c464c]{display:flex;justify-content:space-between;flex-direction:column}.close-btn[data-v-3c2c464c]{position:absolute;top:61px;right:120px;cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
